"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/** Show page links */
var Paginator = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Paginator() {
    var _this;
    _classCallCheck(this, Paginator);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Paginator, [].concat(args));
    _defineProperty(_this, "_changePage", function (page) {
      if (page < 1 || page > _this.props.total) {
        return;
      }
      _this.props.onPageChange(page);
    });
    _defineProperty(_this, "_gotoPage", function (page, e) {
      e.preventDefault();
      if (page < 1 || page > _this.props.total) {
        return;
      }
      _this._changePage(page);
    });
    _defineProperty(_this, "_gotoPrevPage", function (e) {
      e.preventDefault();
      _this._changePage(_this.props.currentPage - 1);
    });
    _defineProperty(_this, "_gotoNextPage", function (e) {
      e.preventDefault();
      _this._changePage(_this.props.currentPage + 1);
    });
    _defineProperty(_this, "_gotoFirstPage", function (e) {
      e.preventDefault();
      _this._changePage(1);
    });
    _defineProperty(_this, "_gotoLastPage", function (e) {
      e.preventDefault();
      _this._changePage(_this.props.total);
    });
    return _this;
  }
  _inherits(Paginator, _React$Component);
  return _createClass(Paginator, [{
    key: "render",
    value: function render() {
      // Don't show anything if there is only one page
      if (this.props.total <= 1) {
        return null;
      }
      var pages = [];
      var isGap = false;
      for (var i = 1; i <= this.props.total; i++) {
        // Don't show gap pages
        if (this.props.total > this.props.minPages && Math.abs(i - this.props.currentPage) > this.props.aroundPages && Math.abs(i) > this.props.edgePages && Math.abs(this.props.total - i) >= this.props.edgePages) {
          if (!isGap) {
            pages.push(/*#__PURE__*/_react["default"].createElement("li", {
              key: i,
              className: "page-item disabled"
            }, /*#__PURE__*/_react["default"].createElement("a", {
              className: "page-link"
            }, "...")));
            isGap = true;
          }
        } else {
          isGap = false;
          pages.push(/*#__PURE__*/_react["default"].createElement("li", {
            key: i,
            className: (0, _classnames["default"])('page-item', i === this.props.currentPage && 'active'),
            onClick: this._gotoPage.bind(null, i)
          }, /*#__PURE__*/_react["default"].createElement("a", {
            className: "page-link",
            href: "#"
          }, i)));
        }
      }

      // Prev and next pages
      if (this.props.isAngularLinks) {
        // Prev page
        pages.unshift(/*#__PURE__*/_react["default"].createElement("li", {
          key: "prev",
          className: (0, _classnames["default"])('page-item', this.props.currentPage === 1 && 'disabled'),
          onClick: this._gotoPrevPage
        }, /*#__PURE__*/_react["default"].createElement("a", {
          className: "page-link",
          href: "#"
        }, "\xAB")));

        // Next page
        pages.push(/*#__PURE__*/_react["default"].createElement("li", {
          key: "next",
          className: (0, _classnames["default"])('page-item', this.props.currentPage === this.props.total && 'disabled'),
          onClick: this._gotoNextPage
        }, /*#__PURE__*/_react["default"].createElement("a", {
          className: "page-link",
          href: "#"
        }, "\xBB")));
      }

      // First and last pages
      if (this.props.isEdgeLinks) {
        // First page
        pages.unshift(/*#__PURE__*/_react["default"].createElement("li", {
          key: "first",
          className: (0, _classnames["default"])('page-item', this.props.currentPage === 1 && 'disabled'),
          onClick: this._gotoFirstPage
        }, /*#__PURE__*/_react["default"].createElement("a", {
          className: "page-link",
          href: "#"
        }, "First")));

        // Last page
        pages.push(/*#__PURE__*/_react["default"].createElement("li", {
          key: "last",
          className: (0, _classnames["default"])('page-item', this.props.currentPage === this.props.total && 'disabled'),
          onClick: this._gotoLastPage
        }, /*#__PURE__*/_react["default"].createElement("a", {
          className: "page-link",
          href: "#"
        }, "Last")));
      }
      return /*#__PURE__*/_react["default"].createElement("ul", {
        className: (0, _classnames["default"])('pagination', 'pagination-sm', _style["default"].paginator, this.props.className)
      }, pages);
    }
  }]);
}(_react["default"].Component);
_defineProperty(Paginator, "propTypes", {
  /** total number of pages. If equal 0 then the component shows nothing */
  total: _propTypes["default"].number,
  /** current page */
  currentPage: _propTypes["default"].number,
  /** minimum number of pages around the current page */
  aroundPages: _propTypes["default"].number,
  /** minimum number of pages at the beggining and at the end */
  edgePages: _propTypes["default"].number,
  /** show "Next" and "Prev" links or not? */
  isAngularLinks: _propTypes["default"].bool,
  /** show "First" and "Last" links or not? */
  isEdgeLinks: _propTypes["default"].bool,
  /** minimum number of pages which will not be splitted */
  minPages: _propTypes["default"].number,
  /** function called after changing page. With params: function(newPage) */
  onPageChange: _propTypes["default"].func,
  /** Additional wrapper class name */
  className: _propTypes["default"].string
});
_defineProperty(Paginator, "defaultProps", {
  total: 0,
  currentPage: 1,
  aroundPages: 3,
  edgePages: 1,
  isAngularLinks: false,
  isEdgeLinks: false,
  minPages: 10,
  onPageChange: function onPageChange() {},
  className: ''
});